module.exports = __webpack_public_path__ + "static/media/Cameroon.ac93a0d6.png";